module.exports = __webpack_public_path__ + "static/img/ban3.2592cc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/ban3.jpg
// module id = PPgu
// module chunks = 55